<template>
    <section class="tag-list">
      <h1 class="tag-list__header">Interacive Elements</h1>
      <div class="tag-list__wrapper">
        <ul>
          <li class="tag-list__item _flxrcs"  v-tooltip.bottom-center="'drag & drop item on video'" v-drag="{ 'dragStart': onDragStart, 'dragEnd': onDragEnd, 'data': val, 'visualIndicator': createVisualIndicator }" v-for="(val, index) in tags" :key="val.key + '-' + index" @click="onSelect(val)">
            <i class="tag-list__item-icon material-icons">
              {{ val.icon || 'add_circle' }}
            </i>
            <span class="tag-list__item-label">
            {{ val.label }}
            </span>
          </li>
        </ul>
        <div ref="visualIndicator" class="tag-list__drag-visual-indicator">
            <i class="tag-list__item-icon material-icons">
              add_circle
            </i>
        </div>
      </div>
    </section>
</template>
<script>

import { mapState, mapMutations, mapActions } from "vuex";
import { metaDataFormDefaults } from './metadataFormFields'

export default {
  name: 'tag-list',
  data() {
    return {
      template: 'generic',
      selectedAlignment: null,
      form: []
    }
  },
  watch: {
    'selection.tag': 'onTagChange'
  },
  computed: {
    ...mapState(['mode']),
    isSelecting: function () {
      return this.mode === null || this.mode === 'playing'
    },
    tags: function() {
      return metaDataFormDefaults()
    }
  },
  components: {
  },
  methods: {
    ...mapMutations(['updateMetadata', 'setTemplate', 'setMode']),
    ...mapActions(['storeImage', 'deleteImageFromStore', 'translate']),
    onSelect(val) {
      console.log("Tag %s with %% selected", val.key, val)
      this.$emit("input", val)
    },
    createVisualIndicator(ev, val) {
      // let el = document.createElement("div")
      let el = this.$refs.visualIndicator.cloneNode(true)
      el.style.border = "1px solid cyan"
      el.style.backgroundColor = "rgba(255, 255, 255, 0.25)"
      el.style.display = "flex"
      let bounds = val.bounds || {
        w: 80,
        h: 80
      }
      el.style.width = (bounds.w || bounds.wh) + 'px'
      el.style.height = (bounds.h || bounds.wh) + 'px'
      return el
    },
    onDragStart(ev, val) {
      console.log("onDragStart from directive", ev, val)
      let dropArea = document.querySelector(".editor .player-outer-wrapper")
      dropArea.classList.add("_is-drag-target")
      // this.setMode("addInteraction")
    },
    onDragEnd(ev, val) {
      console.log("onDragEnd from directive", ev, val)
      val.clientX = ev.clientX
      val.clientY = ev.clientY
      let dropArea = document.querySelector(".editor .player-outer-wrapper")
      dropArea.classList.remove("_is-drag-target")
      // onsole.log("onDragEnd mouse x,y; drop area x,y", ev.clientX, ev.clientY, dabb.left, dabb. top)
      let isWithin = this.isDropWithin(ev, dropArea)
      if (isWithin) {
        this.onSelect(val)
      }
      //this.setMode("editing")
    },
    isDropWithin(ev, target) {
      let bb = target.getBoundingClientRect()
      if (ev.clientX >= bb.left && ev.clientX <=(bb.left + bb.width) && ev.clientY >= bb.top && ev.clientY <= (bb.top + bb.height)) {
        console.log("drop within")
        return true
      } else {
        console.log("drop outside")
        return false
      }
    }
  }
}
</script>
